/**
 * サブドメイン判定に使用する既知のドメインリスト
 */
export const KNOWN_DOMAINS: string[] = [
  'localhost',
  'ana-lounge-reservation.jp',
  'stg.ana-lounge-reservation.jp',
];
